import { OrderTab } from '@src/orders/domain/OrderTab';
import { useOrdersWithFilters } from '@src/orders/hooks/useOrdersWithFilters';

export const useGetActiveOrdersForClient = (
  clientId: string,
  enabled?: boolean,
) => {
  const { orders, isLoading } = useOrdersWithFilters({
    assignedToMe: false,
    page: 1,
    pageSize: 1,
    category: OrderTab.Active,
    clientId,
    enabled,
  });

  return {
    hasActiveOrders: orders.totalOrders > 0,
    activeOrdersCount: orders.totalOrders,
    isLoading,
  };
};
